import { GridStateV2 } from '@schenck/rotec-components';

export const GRID_DATA_DEFAULT: GridStateV2 = {
  filter: [],
  fulltext: '',
  page: 0,
  sort: [],
  total: 0,
  results: [],
  pageSize: 15,
  type: '',
};
